import React from 'react';

import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { ComponentInfo, DisplayGroupRender } from '@components';

export const BottomPanel: React.FC<DisplayGroupProps> = (props: DisplayGroupProps) => {
	return (
		<ComponentInfo name="BottomPanel">
			<DisplayGroupRender displayGroupsProps={props} />
		</ComponentInfo>
	);
};
